import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { MoveFocusInside } from 'react-focus-on';
import { TransitionGroup } from 'react-transition-group';
import { getClassesQuery } from '@pm2/api';
import { InMemoryNavigationProvider, useLocation } from '@provider/navigation';
import { SizeTransition } from '@utils/react';
import { modal, routeWrapper, routeTransitionDurationMs, route } from './modal.style.js';
import { ClassPage } from './page.class.js';
import { Root } from './page.root.js';
import { StudentsPage } from './page.students.js';
import { jsx } from 'react/jsx-runtime';

const makeShareRevisionModalConfig = (revision, options) => ({
  theme: "dialog",
  className: modal,
  content: /*#__PURE__*/jsx(InMemoryNavigationProvider, {
    basePath: `${window.location.pathname}?share-course-revision=`,
    initialPath: "/",
    children: /*#__PURE__*/jsx(ShareRevisionModal, {
      revision: revision
    })
  }),
  ...options
});
function ShareRevisionModal(props) {
  const location = useLocation();
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);

  // begin preloading classes immedately after mounting the modal as they are
  // required for rendering the Classes page
  useQuery(getClassesQuery.useQueryConfig());
  const route$1 = (() => {
    switch (location.pathname) {
      case "/classes":
        return /*#__PURE__*/jsx(ClassPage, {
          selectedClasses: selectedClasses,
          setSelectedStudents: setSelectedStudents,
          setSelectedClasses: setSelectedClasses
        });
      case "/students":
        return /*#__PURE__*/jsx(StudentsPage, {
          selectedStudents: selectedStudents,
          selectedClasses: selectedClasses,
          setSelectedStudents: setSelectedStudents
        });
      case "/":
      default:
        return /*#__PURE__*/jsx(Root, {
          revision: props.revision,
          selectedClasses: selectedClasses,
          selectedStudents: selectedStudents
        });
    }
  })();
  return /*#__PURE__*/jsx(TransitionGroup, {
    component: "div",
    className: routeWrapper,
    children: /*#__PURE__*/jsx(SizeTransition, {
      axis: "vertical",
      swappable: true,
      classNames: route,
      timeout: routeTransitionDurationMs,
      children: ref => /*#__PURE__*/jsx("div", {
        ref: ref,
        className: route,
        children: /*#__PURE__*/jsx(MoveFocusInside, {
          children: route$1
        })
      })
    }, location.pathname)
  });
}

export { makeShareRevisionModalConfig };
//# sourceMappingURL=modal.js.map
